import { SubscribableService } from './subscribable-service';
import { GuidService } from './guid-service';

const modals = {};
let modalIdStack = [];

/**
 * This is our class that is array list of modals which is commonly used by `asModal` and opening modals from epics.
 * It will always build out `modalProperties` and pass it off to modal-manager to always be called. So that it is aware
 * of which modalId it is "managing". When ModalManager is rendered, it will create `onCancel` and `onClose` functions
 * to give to the ModalProvider so that all modals have access and rely on `useModalContext`. Therefore, in making this
 * change we create a ->
 * TODO: remove modalFrameworkMethods from all modals so we no longer prop drill and keep things in context.
 * Optionally this will receive an `onClose` and `onCancel` callback from `asModal` or in epics `modalConfig`.
 */
class ModalServiceClass extends SubscribableService {
  launchModal({ component, props, portalProps, onClose, onCancel }) {
    const modalId = `modal-${GuidService.newGuid()}`;
    modals[modalId] = {
      id: modalId,
      component,
      props,
      portalProps,
      modalProperties: {
        onClose,
        onCancel,
        modalId,
      },
      modalFrameworkMethods: {
        closeModal: (isCancel) => {
          this.closeModalById(modalId, isCancel);
        },
        cancelModal: () => {
          this.closeModalById(modalId, true);
        },
      },
    };
    this.onChange();
    modalIdStack.push(modalId);
    return modalId;
  }

  updateModalById(modalId, { component, props, portalProps, onClose, onCancel }) {
    if (!modals[modalId]) {
      return;
    }
    modals[modalId] = {
      id: modalId,
      component,
      props,
      portalProps,
      modalProperties: {
        onClose,
        onCancel,
        modalId,
      },
      modalFrameworkMethods: {
        closeModal: (isCancel) => {
          this.closeModalById(modalId, isCancel);
        },
        cancelModal: () => {
          this.closeModalById(modalId, true);
        },
      },
    };
    this.onChange();
  }

  closeModalById = (modalId, isCancel = false) => {
    const modalConfig = modals[modalId];
    if (modalConfig === undefined) {
      return;
    }
    delete modals[modalId];
    modalIdStack = modalIdStack.filter((id) => id !== modalId);
    this.onChange();
    // Here for epics
    setTimeout(() => {
      if (modalConfig.modalProperties.onCancel && isCancel) {
        modalConfig.modalProperties.onCancel();
      } else if (modalConfig.modalProperties.onClose) {
        modalConfig.modalProperties.onClose(isCancel);
      }
    }, 0);
  };

  getModals() {
    return modals;
  }

  closeLastOpenModal() {
    if (modalIdStack.length === 0) {
      return;
    }
    const lastModalId = modalIdStack.pop();
    this.closeModalById(lastModalId, true);
  }
}

export const ModalService = new ModalServiceClass();
